// The Roger chart palette (index.css): seven series colours, then a neutral
// grey as the last resort.
export const SERIES_COLOR_COUNT = 7;
export const NEUTRAL_SERIES_COLOR = 'hsl(var(--chart-8))';

/** The nth series colour from the Roger palette, purple first. */
export function chartColor(index: number): string {
  return `hsl(var(--chart-${(index % SERIES_COLOR_COUNT) + 1}))`;
}
